// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.avrorecycling.com/api';

// Token management
export const getToken = () => {
  try {
    return localStorage.getItem('auth_token');
  } catch (error) {
    console.error('Error getting token:', error);
    return null;
  }
};

export const setToken = (token) => {
  try {
    localStorage.setItem('auth_token', token);
    return true;
  } catch (error) {
    console.error('Error setting token:', error);
    return false;
  }
};

export const removeToken = () => {
  try {
    localStorage.removeItem('auth_token');
    return true;
  } catch (error) {
    console.error('Error removing token:', error);
    return false;
  }
};

// Store user ID for later use
export const setUserId = (userId) => {
  try {
    localStorage.setItem('user_id', userId.toString());
    return true;
  } catch (error) {
    console.error('Error setting user ID:', error);
    return false;
  }
};

export const getUserId = () => {
  try {
    return localStorage.getItem('user_id');
  } catch (error) {
    console.error('Error getting user ID:', error);
    return null;
  }
};

export const removeUserId = () => {
  try {
    localStorage.removeItem('user_id');
    return true;
  } catch (error) {
    console.error('Error removing user ID:', error);
    return false;
  }
};

export { API_BASE_URL };

